import generateThunkReducers from '@/data/util/generateThunkReducers';
import { mergeEntityItems } from '@/data/util/sliceHelpers';
import { fetchRipplingPayrollRuns } from '@/integrations/modules/rippling/store/payrollRun/actions/fetchRipplingPayrollRuns';
import { RipplingPayrollRun } from '@/integrations/modules/rippling/store/payrollRun/model';
import RipplingPayrollRunsState from '@/integrations/modules/rippling/store/payrollRun/state';

import { createSlice } from '@reduxjs/toolkit';

export const ripplingPayrollRunsSliceName = 'integrations/rippling/payrollRuns';

export const ripplingPayrollRunsSlice = createSlice({
  name: ripplingPayrollRunsSliceName,
  initialState: new RipplingPayrollRunsState(),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchRipplingPayrollRuns.fulfilled, (state, action) => {
      return mergeEntityItems(state, action.payload, RipplingPayrollRun, 'id');
    });

    generateThunkReducers(builder, ripplingPayrollRunsSliceName);
  },
});

export default ripplingPayrollRunsSlice.reducer;
